export default "__VITE_ASSET__BRxqJCem__"